import React from 'react'
import BackImage from '../components/BackImage'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'

const Home = () => {
  return (
    <div>
        <Navbar/>
        <BackImage/>
        <Footer/>
    </div>
  )
}

export default Home